import { supabase } from "@/supabase";
export async function salvarAvaliacao (disciplina, proprietario, titulo){

    const { data, error } = await supabase
        .from('questoes_listas_questoes')
        .insert([
            { disciplina: disciplina, proprietario: proprietario, titulo: titulo }
        ])
        .select()
        .single()


    return { data, error };

}

export async function salvarQuestaoNaLista (lista, questao, ordem){

    const { data, error } = await supabase
        .from('questoes_questoes_da_lista')
        .insert([
            { lista: lista, questao: questao, ordem: ordem }
        ])
        .select()
        .single()
    if (error) {
        console.log(error.message)
    }

    return data;

}


export async function carregarAvaliacoes(disciplina, proprietario) {
    let query = supabase
        .from('questoes_listas_questoes')
        .select('*, questoes_questoes_da_lista(questao, ordem)')
        .eq("disciplina", disciplina);

    if (proprietario !== null && proprietario !== undefined) {
        query = query.eq("proprietario", proprietario);
    }

    query = query.order('id', { ascending: false });

    const { data, error } = await query;

    if (error) {
        return error;
    }

    console.log(data);

    let avaliacao = data.map(avaliacao => {
        return {
            id: avaliacao.id,
            titulo: avaliacao.titulo,
            proprietario: avaliacao.proprietario,
            questoes: avaliacao.questoes_questoes_da_lista
        };
    });

    return avaliacao;
}


export async function deletarAvaliacao (id){
    const { data, error } = await supabase
        .from('questoes_listas_questoes')
        .delete()
        .eq("id", id)
    return { data, error };
}

export async function atualizarAvaliacao (id, disciplina, titulo){
    const { data, error } = await supabase
        .from('questoes_listas_questoes')
        .update([
            { disciplina: disciplina, titulo: titulo }
        ])
        .eq("id", id)
    return { data, error };
}

export async function carregarQuestoesDaAvalicao (ids){
    const { data, error } = await supabase
        .from('questoes')
        .select('*')
        .in('id', ids)
    
        if(error){
            console.log(error.message)
            return error
        }

    return data
}

export async function excluirQuestaoDaLista (lista, questao){

    const { data, error } = await supabase
        .from('questoes_questoes_da_lista')
        .delete()
        .eq("lista", lista)
        .eq("questao", questao)
        .select()

    if(error){
        console.log(error.message)
        return
    }

    return data;
}

export async function excluirListaQuestoes(id){

    const { data, error } = await supabase
        .from('questoes_listas_questoes')
        .delete()
        .eq("id", id)

    if (error) {
        console.log(error.message)
        return
    }

    return data;
}


export async function atualizarTituloAvalicao (id, titulo){
    const { data, error } = await supabase
        .from('questoes_listas_questoes')
        .update([
            { titulo: titulo }
        ])
        .eq("id", id)

        
    if (error) {
        console.log(error.message)
        return
    }

    return data;
}